import { t } from '@lingui/macro';
import { DistinctPropertyValueFilter } from './DistinctPropertyValueFilter';
import { withFilterErrorBoundary } from './FilterErrorBoundary';
export const partiesFilterLabel = () => t({ message: 'Parties', comment: 'Insights filter: Parties' });
export const PartiesFilter = withFilterErrorBoundary(() => (<DistinctPropertyValueFilter filterKey="metadataDocumentParties" label={partiesFilterLabel()} propertyName="Parties"/>));
